import FormEvent from '@tekion/tekion-base/utils/formEvent';
import eventTypes from '../constants/eventTypes';
export var triggerSubmit = function triggerSubmit(contextId, additional) {
  FormEvent.emit("".concat(eventTypes.ON_SUBMIT, ":").concat(contextId), additional);
};
export var triggerCancel = function triggerCancel(contextId) {
  FormEvent.emit("".concat(eventTypes.ON_CANCEL, ":").concat(contextId));
};
export var triggerFocusPrev = function triggerFocusPrev(className) {
  FormEvent.emit("".concat(eventTypes.FOCUS_PREV), className);
};
export var triggerFocusNext = function triggerFocusNext(className) {
  FormEvent.emit("".concat(eventTypes.FOCUS_NEXT), className);
};